import { createContext, useCallback, useContext } from "react";
import { useAuth } from "@/context/AuthContext";
import { useTenant } from "@/context/TenantContext";
import useResource from "../../../hooks/useResource";
import { dealerAccess } from "../services/dealerPortal";

const DealerPortalContext = createContext(null);
export const useDealerPortal = () => useContext(DealerPortalContext);

/** Display capabilities come from the same scoped service that enforces them. */
export function DealerPortalProvider({ children }) {
  const { user } = useAuth();
  const { merchant } = useTenant();
  const merchantId = merchant?.id;
  const userId = user?.id;
  const dealerId = user?.dealer_id;
  const loader = useCallback(signal => merchantId && userId && dealerId ? dealerAccess(signal)
    : Promise.resolve(null), [merchantId, userId, dealerId]);
  const resource = useResource(loader);
  const capabilities = resource.error || resource.loading ? {} : resource.data?.capabilities || {};
  return <DealerPortalContext.Provider value={{ ...resource, dealer: resource.data?.dealer || null,
    capabilities: { commission: capabilities.commission === true, leaderboard: capabilities.leaderboard === true } }}>
    {children}
  </DealerPortalContext.Provider>;
}
